import { render, staticRenderFns } from "./SideDrawerChat.vue?vue&type=template&id=7a60628a&"
import script from "./SideDrawerChat.vue?vue&type=script&lang=js&"
export * from "./SideDrawerChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports